
import { padStart } from './padStart';

const dollarChars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']

export function dollar(e) {
  e.preventDefault()
  const { target, key, keyCode } = e
  let value = target.value

  if (keyCode === 8 || keyCode === 46) {
    value = value.substring(0, value.length - 1)
  } else {
    if (!~dollarChars.indexOf(key)) {
      return
    }
    value = value + key
  }

  const cleanValue = value.replace(/[^\d]/g, '').replace(/^0+/, '')
  let paddeed = cleanValue

  if (cleanValue.length < 4) {
    paddeed = padStart(cleanValue, 4, '0')
  }

  const splitted = paddeed.split('')
  splitted.splice(paddeed.length - 2, 0, '.')
  target.value = splitted.join('')
}

function currency(num) {
  if (num === void 0 || num ===  null || num === '' || num === NaN) {
    return
  }

  let [int = '', dec = ''] = String(Number(num).toFixed(2)).split('.')
  //let [int = '', dec = ''] = String(num).split('.')

  if (int.length < 2) {
    int = padStart(int, 2, '0')
  }
  if (dec.length < 2) {
    dec = padStart(dec, 2, '0').split('').reverse().join('')
  }

  return `${int}.${dec}`
}

function maxCheck(num) {
  if (num < 99) {
    return num
  } else {
    return 1
  }
}

function maxtwo(num) {
  if (num.length <= 2) {
    return num
  }
}

function maxFive(num) {
  if (num < 99999) {
    return num
  } else {
    return num
  }
}
function meaninful(v) {
  return (v === '' || v === void 0 || v === null || (typeof v === 'number' && isNaN(v))) ? '' : v
}

export const columnFormatters = {
  'MultiOf': maxCheck,
  'MbksStyleSeq': maxCheck,
  'MBKSExtCost': meaninful,
  'MBKSExtRetail': meaninful,
  'MBKSMU': meaninful,
  'MasterStyle': maxFive,
  'Cost': currency,
  'TicketRetail': currency,
  'CompareAt': currency,
}


// WEBPACK FOOTER //
// ./utilities/formatters.js